<template>

  <div class="benefits  benefits--mobile shadow-base divide-y divide-very-light-gray">
    <div v-for="benefit in benefit_banners" class="flex justify-start items-center py-[10px]">
      <img :src="benefit.image.webp" :srcset="benefit.image.source" width="24" height="24" class="benefits__icon" :alt="benefit.title">
      <div class="benefits__text">
        <a :href="benefit.link" :title="benefit.title">
          {{ benefit.title }}
        </a>
      </div>
    </div>
  </div>

  <div class="benefits  hide-md shadow-base">
    <div v-for="(benefit, index) in benefit_banners" class="benefits__item">
      <img :src="benefit.image.webp" :srcset="benefit.image.source" width="24" height="24" class="benefits__icon" :alt="benefit.title">
      <div class="benefits__text">
        <a :href="benefit.link" :title="benefit.title">
          {{ benefit.title }}
          <div>
             {{ benefit.sub_title }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:  "Benefits",
  props: [
    'benefit_banners',
  ],
}
</script>
